import React, { useEffect } from 'react'
import Navbar from 'src/components/Navbar/Navbar'
import SearchNewsContent from 'src/components/News/SearchNewsContent/SearchNewsContent'
import Footer from 'src/components/Footer/Footer'

const SearchNewsPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Navbar />
      <SearchNewsContent />
      <Footer />
    </>
  )
}

export default SearchNewsPage
